import SessionManagerRecord, { SessionManagerRecordSource } from '../lib/SessionManagerRecord.js';
import ApplicationUser from './ApplicationUser.js';
class Preferences extends SessionManagerRecord {
    initialize(props) {
        var _a, _b;
        super.initialize(props);
        this.general = (_a = this.general) !== null && _a !== void 0 ? _a : {};
        this.info = (_b = this.info) !== null && _b !== void 0 ? _b : {};
        if (props) {
            this.user = new ApplicationUser(props.user);
        }
    }
    /**
     * @param {ApplicationUser} user
     * @return {Promise<Preferences>}
     */
    static async forUser(user) {
        return Preferences.find({ user: user.id })
            .then((result) => result !== null && result !== void 0 ? result : new Preferences({ user }))
            .catch((error) => {
            const { response } = error;
            if (RECOVERABLE_STATUSES.includes(response.status)) {
                return new Preferences({ user });
            }
            return Promise.reject(error);
        });
    }
}
const RECOVERABLE_STATUSES = [403, 404];
Preferences.$AR = {
    url: '',
    SourceClass: SessionManagerRecordSource,
};
export default Preferences;
